import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import queryString from 'query-string'
// import { withRouter } from 'react-router-dom'
import { Toast } from '../components/ui'
import { login, clearErrors, getAccountFromDomain } from '../redux/actions/auth'
import * as rdd from 'react-device-detect'
import {
  Grid, makeStyles, Button, Typography,
  // FilledInput, InputAdornment, IconButton,  InputLabel
  FormControl,
  FilledInput, InputLabel, Paper, Dialog, DialogTitle,
  DialogContent, DialogActions
} from '@material-ui/core'

import { NotificationToast } from '../components/ui/tools/Toast'
import log from 'loglevel'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL
const version = process.env.REACT_APP_VERSION

// import Visibility from '@material-ui/icons/Visibility'
// import VisibilityOff from '@material-ui/icons/VisibilityOff'

const useStyles = makeStyles((theme) => ({
  loginContainer: {
    height: '95vh',
    width: '100vw'
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    '&:disabled': {
      backgroundColor: 'rgba(57, 132, 247, 0.50)'
    }
  },
  mobileForgotPass: {
    textTransform: 'none',
    color: '#3984f7',
    '&:focus': {
      outline: 'none'
    }
  },
  snackRoot: {
    padding: 'none'
  },
  snackCloseIcon: {
    padding: theme.spacing(0.5),
    color: '#FFFFFF'
  },
  paperRoot: {
    backgroundColor: '#3134384a'
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&.Mui-focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  underline: {
    '&:after': {
      borderBottomColor: '#3984f7'
    }
  }
}))

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  ) ||
  // If using a local IP for mobile
  window.location.hostname.match(
    /^192(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  ) ||
  window.location.hostname.match(
    /^172(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
)

// !!! This is for testing ONLY and should be removed or disabled otherwise
// rdd.isMobile = true

const Login = (props) => {
  const classes = useStyles()
  const textClasses = useTextStyles()
  const dispatch = useDispatch()

  const parsedProps = queryString.parse(props.location.search)
  const bypassSSO = useRef(parsedProps && Boolean(parsedProps.bypassSSO))

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [accountID, setAccountID] = useState('')

  const [loginDisabled, setLoginDisabled] = useState(false)
  // const [showPassword, setShowPassword] = useState(false)
  // const [authType, setAuthType] = useState(null)
  // const [authEndpoint, setAuthEndpoint] = useState(null)

  const { message, error } = useSelector(state => state.auth)

  useEffect(() => {
    const acquireDomain = async () => {
      let subdomain = window.location.hostname
      if (isLocalhost) {
        subdomain = 'console.learnsafe.com'
      }

      const responseInfo = await getAccountFromDomain(subdomain)
      if (responseInfo && responseInfo.accountID) {
        // set state to accountID
        setAccountID(responseInfo.accountID)

        // Set SSO settings if populated
        if (responseInfo.auth_type && responseInfo.auth_endpoint) {
          // setAuthType(response.data.auth_type)
          // setAuthEndpoint(response.data.auth_endpoint)
          // check query params; if bypassSSO is set, do not automatically route
          if (!bypassSSO.current) {
            window.location.href = `${api}${responseInfo.auth_endpoint}`
          }
        }
      } else {
        Toast(true, 'Error getting account settings. Check that the url in your browser window is correct and attempt to reload the page.')
      }
    }

    if (window && window.location && window.location.hostname) { acquireDomain() }
  }, [])

  useMemo(() => {
    if (message) {
      // log.info('we got a message')
      Toast(error, message)
      // reset error, message
      dispatch(clearErrors())
    }
  }, [message, dispatch, error])

  // const handleSSOLogin = (e) => {
  //   e.stopPropagation()
  //   e.preventDefault()
  //   if (!bypassSSO) {
  //     window.location.href = `${api}${authEndpoint}`
  //   }
  //   return true
  // }

  // handleGoogleLogin () {
  //   // e.stopPropagation()
  //   // e.preventDefault()
  //   window.location.href = `${api}/sso/saml/google`
  //   return true
  // }

  const handleSubmit = async (e) => {
    if (e) { e.preventDefault() }
    log.info('submitted login info')
    setLoginDisabled(true)
    dispatch(login(username, password, accountID, fireLogin))
  }

  const fireLogin = () => { setLoginDisabled(false) }

  const handleFormEnter = (e) => {
    if (e.key) {
      if (e.key.toUpperCase() === 'ENTER') {
        if (username === '') {
          return NotificationToast(false, 'Missing email!', true)
        }
        if (password === '') {
          return NotificationToast(false, 'Missing password!', true)
        }
        handleSubmit()
      }
    }
  }

  const [snackTrue, setSnackTrue] = useState(false)
  const handleMobilePassChange = () => { setSnackTrue((prev) => !prev) }

  const isEnabled = username !== '' && password !== '' && accountID !== ''

  return (
    <>
      <Grid container direction='row' className={classes.loginContainer} justify='center' alignItems='center'>
        {rdd.isMobile
          ? (
            <Grid container item direction='column' xs={11}>
              <Paper className={classes.paperRoot}>
                <Grid container item direction='row' justify='center'>
                  <Grid item xs={10} style={{ marginTop: '1em' }}>
                    <h1>
                      <img src={require('../assets/images/logo2.png')} className='logo' alt='LearnSafe Cloud' />
                    </h1>
                  </Grid>
                </Grid>

                <Grid container item direction='row' justify='center'>
                  <Grid item>
                    <Typography variant='h5' style={{ fontWeight: 'bold', color: '#FFFFFF' }} className='text-center unselectable'>Welcome</Typography>
                  </Grid>
                </Grid>

                <Grid container item direction='row' justify='center' className='my-3'>
                  <FormControl fullWidth className='mx-3'>
                    <InputLabel htmlFor='username' variant='filled'>Email Address</InputLabel>
                    <FilledInput
                      fullWidth
                      inputMode='email'
                      type='email'
                      placeholder='Email Address'
                      onChange={(e) => setUsername(e.target.value)}
                      value={username}
                      id='username'
                      classes={textClasses}
                      onKeyDown={handleFormEnter}
                    />
                  </FormControl>
                </Grid>

                <Grid container item direction='row' justify='center' className='my-3'>
                  <FormControl fullWidth className='mx-3'>
                    <InputLabel htmlFor='password' variant='filled'>Password</InputLabel>
                    <FilledInput
                      type='password'
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      placeholder='Password'
                      id='password'
                      classes={textClasses}
                      onKeyDown={handleFormEnter}
                    />
                  </FormControl>
                </Grid>

                <Grid container item direction='row' justify='center' className='my-2'>
                  <Grid item xs={6} xl={5}>
                    <Button
                      size='medium'
                      fullWidth
                      type='submit'
                      variant='contained'
                      className={classes.blueBtn}
                      onClick={handleSubmit}
                      disabled={!isEnabled || loginDisabled}
                    >
                      <Typography variant='h6' style={{ textTransform: 'none' }}>Log In</Typography>
                    </Button>
                  </Grid>
                </Grid>

                <Grid container item direction='row' justify='center' className='my-2' style={{ marginBottom: '1em' }}>
                  <Button variant='text' color='primary' classes={{ textPrimary: classes.mobileForgotPass }} onClick={handleMobilePassChange}>Forgot Password?</Button>
                </Grid>
              </Paper>
              <Dialog
                classes={{ root: classes.snackRoot }}
                open={snackTrue}
                onClose={() => setSnackTrue(false)}
              >
                <DialogTitle>
                  <Typography variant='h6' component='div' style={{ color: '#3984f7', fontWeight: 'bold', textAlign: 'center' }}>Heads up!</Typography>
                </DialogTitle>
                <DialogContent>
                  <Typography>This action can only be preformed from a desktop.</Typography>
                </DialogContent>
                <DialogActions>
                  <Button variant='text' color='primary' classes={{ textPrimary: classes.mobileForgotPass }} onClick={handleMobilePassChange}>Ok</Button>
                </DialogActions>
              </Dialog>
            </Grid>
          )
          : (
            <Grid container item direction='column' xs={6}>
              <Grid container item direction='row' justify='center'>
                <Grid item xs={6} xl={5}>
                  <h1>
                    <img src={require('../assets/images/logo2.png')} className='logo' alt='LearnSafe Cloud' />
                  </h1>
                </Grid>
              </Grid>

              <Grid container item direction='row' justify='center'>
                <Grid item xs={6} xl={5}>
                  <h2 className='text-center unselectable'>Welcome</h2>
                </Grid>
              </Grid>

              <Grid container item direction='row' justify='center' className='my-3'>
                <Grid item xs={6} xl={5}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor='username' variant='filled'>Email Address</InputLabel>
                    <FilledInput
                      inputMode='email'
                      type='email'
                      placeholder='Email Address'
                      onChange={(e) => setUsername(e.target.value)}
                      value={username}
                      id='username'
                      classes={textClasses}
                      onKeyDown={handleFormEnter}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container item direction='row' justify='center' className='my-3'>
                <Grid item xs={6} xl={5}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor='password' variant='filled'>Password</InputLabel>
                    <FilledInput
                      type='password'
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      placeholder='Password'
                      id='password'
                      classes={textClasses}
                      onKeyDown={handleFormEnter}
                    />
                  </FormControl>
                  {/* <FormControl fullWidth variant='filled'>
                    <InputLabel htmlFor='login-password'>Password</InputLabel>
                    <FilledInput
                      id='login-password'
                      value={password}
                      placeholder='Password'
                      className={textClasses.root}
                      onChange={(e) => setPassword(e.target.value)}
                      fullWidth
                      variant='filled'
                      type={showPassword ? 'text' : 'password'}
                      endAdornment={
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle password visibility'
                            onClick={(e) => {
                              e.preventDefault()
                              setShowPassword(!showPassword)
                            }}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl> */}
                </Grid>
              </Grid>

              <Grid container item direction='row' justify='center' className='my-2'>
                <Grid item xs={6} xl={5}>
                  <Button
                    size='large'
                    fullWidth
                    type='submit'
                    variant='contained'
                    className={classes.blueBtn}
                    onClick={handleSubmit}
                    disabled={!isEnabled || loginDisabled}
                  >
                    <Typography variant='h6' style={{ textTransform: 'none' }}>Log In</Typography>
                  </Button>
                </Grid>
              </Grid>
              <Grid container item direction='row' justify='center' className='my-2'>
                <a className='link-text' href='password-reset'>Forgot Password?</a>
              </Grid>

            </Grid>
          )}
      </Grid>

      <Grid item container direction='row' justify='flex-end'>
        <Typography style={{ marginRight: '2rem' }}>{version}</Typography>
      </Grid>
    </>
  )
}

export default Login
